// ======================================================
// NOOK IMPACT
// PARTE 1
// ======================================================

const DONATION_PER_PRODUCT = 5000;

// ------------------------------------------------------
// GUARDAR FUNDACIÓN EN SHOPIFY
// ------------------------------------------------------

async function saveFoundationToCart(foundation) {

  try {

    await fetch("/cart/update.js", {

      method: "POST",

      headers: {
        "Content-Type": "application/json"
      },

      body: JSON.stringify({

        attributes: {

          foundation: foundation

        }

      })

    });

  } catch (error) {

    console.error(error);

  }

}

// ------------------------------------------------------
// LEER FUNDACIÓN
// ------------------------------------------------------

function getFoundation() {

  const saved = localStorage.getItem("nookFoundation");

  if (!saved) return null;

  try {

    return JSON.parse(saved);

  } catch (e) {

    console.error(e);

    return null;

  }

}

// ------------------------------------------------------
// RENDERIZAR TARJETA
// ------------------------------------------------------

function renderFoundation() {

  const foundation = getFoundation();

  const reward = document.getElementById("NookReward");

  if (!reward) return;

  // ==========================
  // NO HAY FUNDACIÓN
  // ==========================

  if (!foundation) {

    reward.style.display = "none";

    return;

  }

  // ==========================
  // NO PARTICIPAR
  // ==========================

  if (foundation.slug === "none") {

    reward.style.display = "block";

    document.getElementById("NookRewardFoundation").textContent =
      "No participar";

    document.getElementById("NookRewardDescription").textContent =
      "Tu compra continuará sin descuento y sin generar una donación.";

    document.getElementById("NookRewardImage").innerHTML = "";

    document.getElementById("NookImpactDonation").textContent =
      "$0";

    document.getElementById("NookRewardAmount").textContent =
      "$0";

    document.getElementById("NookCouponCode").textContent =
      "-";

    return;

  }

  // ==========================
  // FUNDACIÓN NORMAL
  // ==========================

  reward.style.display = "block";

  document.getElementById("NookRewardFoundation").textContent =
    foundation.nombre;

  document.getElementById("NookRewardDescription").textContent =
    foundation.descripcion;

  document.getElementById("NookRewardImage").innerHTML =
    foundation.logo
      ? `<img src="${foundation.logo}" alt="${foundation.nombre}">`
      : "";

}
// ------------------------------------------------------
// ACTUALIZAR DONACIÓN / DESCUENTO
// ------------------------------------------------------

async function updateImpactAmount() {

  try {

    const cart = await fetch("/cart.js").then(r => r.json());

    const foundation = getFoundation();

    const donation =
      document.getElementById("NookImpactDonation");

    const reward =
      document.getElementById("NookRewardAmount");

    const coupon =
      document.getElementById("NookCouponCode");

    // ======================================
    // NO PARTICIPAR
    // ======================================

    if (foundation && foundation.slug === "none") {

      if (donation) donation.textContent = "$0";

      if (reward) reward.textContent = "$0";

      if (coupon) coupon.textContent = "-";

      return;

    }

    // ======================================
    // CÁLCULOS
    // ======================================

    const amount = cart.item_count * DONATION_PER_PRODUCT;

    if (donation) {

      donation.textContent =
        "$" + amount.toLocaleString("es-CO");

    }

    if (reward) {

      reward.textContent =
        "-$" + amount.toLocaleString("es-CO");

    }

    if (coupon) {

      const savedCoupon =
        localStorage.getItem("nookDiscountCode");

      coupon.textContent =
        savedCoupon || ("PROPOSITO" + (amount / 1000));

    }

  } catch (error) {

    console.error(error);

  }

}

// ------------------------------------------------------
// INICIALIZAR
// ------------------------------------------------------

function initNookImpact() {

  const impact = document.getElementById("NookImpact");

  if (!impact) return;

  renderFoundation();

  updateImpactAmount();

  const toggle = document.getElementById("NookImpactToggle");

  if (!toggle) return;

  if (toggle.dataset.loaded === "true") return;

  toggle.dataset.loaded = "true";

  toggle.addEventListener("click", () => {

    impact.classList.toggle("is-collapsed");

    toggle.innerHTML =
      impact.classList.contains("is-collapsed")
        ? "▼"
        : "✕";

  });

}
// ======================================================
// EVENTOS
// ======================================================

document.addEventListener(
  "DOMContentLoaded",
  initNookImpact
);

document.addEventListener(
  "shopify:section:load",
  initNookImpact
);

document.addEventListener(
  "nook:cart-updated",
  () => {

    renderFoundation();

    updateImpactAmount();

  }
);

document.addEventListener(
  "nook:foundation-updated",
  () => {

    renderFoundation();

    updateImpactAmount();

  }
);

// ======================================================
// COPIAR CUPÓN
// ======================================================

document.addEventListener("click", async (event) => {

  const button = event.target.closest("#NookCopyCoupon");

  if (!button) return;

  const coupon =
    document.getElementById("NookCouponCode")?.textContent;

  if (!coupon || coupon === "-") return;

  try {

    await navigator.clipboard.writeText(coupon);

    const original = button.textContent;

    button.textContent = "✅ Copiado";

    setTimeout(() => {

      button.textContent = original;

    }, 2000);

  } catch (error) {

    console.error(error);

  }

});

// ======================================================
// CAMBIAR FUNDACIÓN
// ======================================================

document.addEventListener("click", (event) => {

  const button =
    event.target.closest("#NookChangeFoundation");

  if (!button) return;

  event.preventDefault();

  const drawer =
    document.querySelector("theme-drawer");

  if (drawer && drawer.close) {

    drawer.close();

  }

  setTimeout(() => {

    const impact =
      document.getElementById("NookImpact");

    if (impact) {

      impact.scrollIntoView({

        behavior: "smooth",

        block: "center"

      });

    }

  }, 300);

});
// ======================================================
// CHECKOUT CON DESCUENTO AUTOMÁTICO
// ======================================================

document.addEventListener("click", function (e) {

  const checkout = e.target.closest("#checkout");

  if (!checkout) return;

  const coupon = localStorage.getItem("nookDiscountCode");

  if (!coupon) return;

  e.preventDefault();

  window.location.href =
    "/discount/" +
    coupon +
    "?redirect=/checkout";

});
// ======================================================
// NOOK BUY NOW
// ======================================================

document.addEventListener("click", async (e) => {

  const button = e.target.closest("#NookBuyNow");

  if (!button) return;

  e.preventDefault();

  button.disabled = true;
  button.textContent = "Preparando compra...";

  try {

    const form = document.querySelector('form[action*="/cart/add"]');

    if (!form) throw new Error("Formulario no encontrado.");

    const data = new FormData(form);

// Fuerza la cantidad actual
const qtyInput = document.querySelector('input[name="quantity"]');

if (qtyInput) {
  data.set("quantity", qtyInput.value);
}

await fetch("/cart/add.js", {
  method: "POST",
  body: data
});
await new Promise(resolve => setTimeout(resolve, 400));
    // Calcular nuevamente el cupón según la cantidad actual
const qty = parseInt(data.get("quantity")) || 1;

const coupon = "PROPOSITO" + (qty * 5);

// Guardarlo para el botón Pagar del carrito
localStorage.setItem("nookDiscountCode", coupon);

// Ir al checkout
window.location.href =
  "/discount/" +
  coupon +
  "?redirect=/checkout";

  } catch (error) {

    console.error(error);

    button.disabled = false;
    button.textContent = "Comprar ahora";

  }

});
// ======================================
// OCULTAR SHOPIFY BUY NOW
// ======================================

document.addEventListener("DOMContentLoaded", () => {

  const observer = new MutationObserver(() => {

    document.querySelectorAll(".accelerated-checkout-block").forEach(el => {

      el.style.display = "none";

    });

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
// ============================================================
// NOOK — ACTUALIZAR CUPÓN SEGÚN CANTIDAD DEL CARRITO
// ============================================================

(function () {

  let lastCartQuantity = null;

  async function updateNookDiscountFromCart() {

    try {

      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      const cart = await response.json();

      // Sumar todas las unidades del carrito
      const totalQuantity = cart.items.reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      );

      // Carrito vacío
      if (totalQuantity <= 0) {
        localStorage.removeItem('nookDiscountCode');
        lastCartQuantity = 0;
        return;
      }

      // No hacer nada si la cantidad no cambió
      if (totalQuantity === lastCartQuantity) {
        return;
      }

      lastCartQuantity = totalQuantity;

      // Calcular cupón
      const coupon = 'PROPOSITO' + (totalQuantity * 5);

      // Guardar nuevo cupón
      localStorage.setItem('nookDiscountCode', coupon);

      console.log(
        'NOOK:',
        totalQuantity,
        'unidades →',
        coupon
      );

    } catch (error) {

      console.error(
        'NOOK: error actualizando descuento',
        error
      );

    }

  }

  // Detectar cambios reales del carrito Shopify
  document.addEventListener(
    'shopify:cart:lines-update',
    function () {
      setTimeout(updateNookDiscountFromCart, 500);
    }
  );

  // Inicializar al cargar
  updateNookDiscountFromCart();

})();